import React, { Component, Fragment } from "react";
import Time from "react-time-format";
import { connect } from "react-redux";
import { change_Lang } from "../../actions/Helper_action";
import NumberFormat from "react-number-format";
import KurdishSoraniNumbersToWords from "kurdish-numbers-to-words/Sorani.js";
import n2wordsEN from "n2words/lib/i18n/AR.mjs";
export class PrintViewLoan extends Component {
 render() {
  const {
   change_Lang,
   viewLoanRecipe,
   primary_logo_bill,
   lang,
   name_arb,
   name_en,
   name_krd,
   invoiceNumber,
  } = this.props;
  let numberWordsSorani =
   viewLoanRecipe.amount !== ""
    ? KurdishSoraniNumbersToWords.convert(viewLoanRecipe.amount)
    : 0;
  let numWords1 =
   viewLoanRecipe.amount !== undefined && viewLoanRecipe.amount !== null
    ? n2wordsEN(parseFloat(viewLoanRecipe.amount.toString().replace(/,/g, "")))
    : 0;
  return (
   <Fragment>
    <div>
     <div class="row">
      <div class="col-12  ">
       <img
        src={primary_logo_bill}
        alt="logo"
        className="img-fluid img-responsive"
        style={{
         position: "relative",
         width: "100%",
        }}
       />
      </div>
     </div>
     <div class="row fk mt-3">
      <div class="col-4">
       <p
        style={{
         fontSize: "21px",
         color: "#000",
         textAlign: "right",
         fontWeight: "bold",
        }}
        class=" text-uppercase"
       >
        &nbsp;&nbsp;{change_Lang("date")} :&nbsp;
        <Time
         value={viewLoanRecipe.createdAt}
         format="hh:mm:ss"
         style={{
          fontSize: "21px",
          color: "#342800",
          fontWeight: "bold",
         }}
        />
        &nbsp;-{" "}
        <Time
         value={viewLoanRecipe.date}
         format="YYYY-MM-DD"
         style={{
          fontSize: "21px",
          color: "#000",
          fontWeight: "bold",
         }}
        />
       </p>
      </div>
      <div class="col-4 ">
       <p
        style={{
         fontSize: "24px",
         color: "black",
         fontWeight: "bold",
         margin: "0px 0px 0px 0px",
        }}
        class=" d-flex justify-content-center"
       >
        ({change_Lang("loan receipts")})
       </p>
      </div>
      <div class="col-4 text-left">
       <p
        style={{
         fontSize: "21px",
         color: "#000",
         fontWeight: "bold",
        }}
        class=" text-uppercase"
       >
        ژ.پسوولە#&nbsp;
        {invoiceNumber}&nbsp;
       </p>
      </div>
     </div>
     {/* first row */}
     <div class="row " style={{ width: "100%", backgroundColor: "#f4f4f6" }}>
      <div class="col-3 d-flex justify-content-start">
       {" "}
       <label
        style={{
         fontSize: "21px",
         color: "black",
         fontWeight: "bold",
        }}
        class=" col-form-label fk"
       >
        وەرگر/المستلم :
       </label>
      </div>
      <div class="col-6 d-flex justify-content-center">
       {" "}
       <label
        className="fk col-form-label d-flex justify-content-start"
        style={{
         fontSize: "21px",
         color: "black",
        }}
       >
        {viewLoanRecipe.type !== "PayBorrower"
         ? `${viewLoanRecipe.agentId && viewLoanRecipe.agentId.fname} ${
            viewLoanRecipe.agentId && viewLoanRecipe.agentId.lname
           }`
         : viewLoanRecipe.borrowerName}
       </label>
      </div>
      <div class="col-3 d-flex justify-content-end">
       <label
        style={{
         fontSize: "21px",
         color: "black",
         fontWeight: "bold",
        }}
        class=" col-form-label fkb"
       >
        : Receipt from
       </label>
      </div>
     </div>
     {/* second row */}
     <div class="row" style={{ width: "100%", backgroundColor: "white" }}>
      <div class="col-3 d-flex justify-content-start">
       {" "}
       <label
        style={{
         fontSize: "21px",
         color: "black",
         fontWeight: "bold",
        }}
        class=" col-form-label fk"
       >
        بڕی پارە/مبلغ و قدره :
       </label>
      </div>
      <div class="col-6 d-flex justify-content-center">
       {" "}
       <NumberFormat
        displayType="text"
        thousandSeparator={true}
        value={viewLoanRecipe.amount}
        style={{
         fontSize: "21px",
         color: "black",
        }}
        className="col-form-label"
        prefix={`${viewLoanRecipe.currency === "dolar" ? "$" : "ID"}`}
       />
       &nbsp;&nbsp;
       <span className="fk" style={{ fontWeight: "bold", marginTop: "12px" }}>
        {" "}
        {lang === "krd" ? numberWordsSorani : numWords1}&nbsp;
        {`${viewLoanRecipe.currency === "dolar" ? "دۆلاری ئەمریکی" : "دینار"}`}
        {change_Lang("Only")}
       </span>
      </div>
      <div class="col-3 d-flex justify-content-end">
       {" "}
       <label
        style={{
         fontSize: "21px",
         color: "black",
         fontWeight: "bold",
        }}
        class=" col-form-label fkb"
       >
        : Amount
       </label>
      </div>
     </div>
     {/* third row */}
     <div class="row" style={{ width: "100%", backgroundColor: "#f4f4f6" }}>
      <div class="col-3 d-flex justify-content-start">
       {" "}
       <label
        style={{
         fontSize: "21px",
         color: "black",
         fontWeight: "bold",
        }}
        class=" col-form-label fk"
       >
        لە بڕی / وذلك عن :
       </label>
      </div>
      <div class="col-6 d-flex justify-content-center">
       <span
        className="fk d-flex justify-content-center mt-2"
        style={{
         fontSize: "20px",
         color: "black",
         textAlign: "justify",
         fontWeight: "bold",
        }}
       >
        {viewLoanRecipe && change_Lang(viewLoanRecipe.type)}
       </span>
      </div>
      <div class="col-3 d-flex justify-content-end">
       {" "}
       <label
        style={{
         fontSize: "21px",
         color: "black",
         fontWeight: "bold",
        }}
        class=" col-form-label fkb"
       >
        : For
       </label>
      </div>
     </div>
     {/* five row */}
     <div class="row" style={{ width: "100%", backgroundColor: "white" }}>
      <div class="col-3 d-flex justify-content-start">
       {" "}
       <label
        style={{
         fontSize: "21px",
         color: "black",
         fontWeight: "bold",
        }}
        class=" col-form-label fk"
       >
        پارەدەر / الدافع :
       </label>
      </div>
      <div class="col-6 d-flex justify-content-center">
       {" "}
       <label
        className="fk col-form-label"
        style={{
         fontSize: "21px",
         color: "black",
        }}
       >
        {viewLoanRecipe.type !== "PayBorrower"
         ? viewLoanRecipe.borrowerName
         : `${viewLoanRecipe.agentId && viewLoanRecipe.agentId.fname} ${
            viewLoanRecipe.agentId && viewLoanRecipe.agentId.lname
           }`}
       </label>
      </div>
      <div class="col-3 d-flex justify-content-end">
       <label
        style={{
         fontSize: "21px",
         color: "black",
         fontWeight: "bold",
        }}
        class=" col-form-label"
       >
        : Receptor
       </label>
      </div>
     </div>
     {/* note */}
     <div class="row" style={{ width: "100%", backgroundColor: "#f4f4f6" }}>
      <div class="col-3 d-flex justify-content-start">
       {" "}
       <label
        style={{
         fontSize: "21px",
         color: "black",
         fontWeight: "bold",
        }}
        class=" col-form-label fk"
       >
        تێبینی / الملاحظات :
       </label>
      </div>
      <div class="col-6 d-flex justify-content-center">
       {" "}
       <label
        className="fk col-form-label"
        style={{
         fontSize: "18px",
         color: "black",
        }}
       >
        {viewLoanRecipe.notes}
       </label>
      </div>
      <div class="col-3 d-flex justify-content-end">
       <label
        style={{
         fontSize: "21px",
         color: "black",
         fontWeight: "bold",
        }}
        class=" col-form-label"
       >
        : Note
       </label>
      </div>
     </div>
     {/* six row */}
     <br /> <br /> <br />
     <div class="row">
      <div class="col-4 d-flex justify-content-center">
       {" "}
       <label
        style={{
         fontSize: "21px",
         color: "black",
         fontWeight: "bold",
        }}
        class=" col-form-label fk"
       >
        واژووی ڕێکخەر/ توقيع
       </label>
      </div>
      <div class="col-4 d-flex justify-content-center">
       {" "}
       <label
        style={{
         fontSize: "21px",
         color: "black",
         fontWeight: "bold",
        }}
        class=" col-form-label fk"
       >
        (پارەدەر)&nbsp;واژوو / توقيع
       </label>
      </div>
      <div class="col-4 d-flex justify-content-center">
       {" "}
       <label
        style={{
         fontSize: "21px",
         color: "black",
         fontWeight: "bold",
        }}
        class=" col-form-label fk"
       >
        (پارەوەرگر)&nbsp;واژوو / توقيع
       </label>
      </div>
      <div class="col-4 d-flex justify-content-center">
       {" "}
       <label
        style={{
         fontSize: "21px",
         color: "black",
         fontWeight: "bold",
        }}
        class=" col-form-label fk"
       >
        {lang === "krd" ? name_krd : lang === "en" ? name_en : name_arb}
       </label>
      </div>
      <div class="col-4 d-flex justify-content-center">
       {" "}
       <label
        style={{
         fontSize: "21px",
         color: "black",
         fontWeight: "bold",
         textAlign: "center",
        }}
        class=" col-form-label fk"
       >
        {viewLoanRecipe.type !== "PayBorrower"
         ? viewLoanRecipe.borrowerName
         : `${viewLoanRecipe.agentId && viewLoanRecipe.agentId.fname} ${
            viewLoanRecipe.agentId && viewLoanRecipe.agentId.lname
           }`}
       </label>
      </div>
      <div class="col-4 d-flex justify-content-center">
       {" "}
       <label
        style={{
         fontSize: "21px",
         color: "black",
         fontWeight: "bold",
         textAlign: "center",
        }}
        class=" col-form-label fk"
       >
        {viewLoanRecipe.type !== "PayBorrower"
         ? `${viewLoanRecipe.agentId && viewLoanRecipe.agentId.fname} ${
            viewLoanRecipe.agentId && viewLoanRecipe.agentId.lname
           }`
         : viewLoanRecipe.borrowerName}
       </label>
      </div>
     </div>
    </div>
    <hr style={{ border: "1px dashed black" }} />
    {/* Second Invoice */}
    <br />
    <div>
     <div class="row">
      <div class="col-12  ">
       <img
        src={primary_logo_bill}
        alt="logo"
        className="img-fluid img-responsive"
        style={{
         position: "relative",
         width: "100%",
        }}
       />
      </div>
     </div>
     <div class="row fk mt-3">
      <div class="col-4">
       <p
        style={{
         fontSize: "21px",
         color: "#000",
         textAlign: "right",
         fontWeight: "bold",
        }}
        class=" text-uppercase"
       >
        &nbsp;&nbsp;{change_Lang("date")} :&nbsp;
        <Time
         value={viewLoanRecipe.createdAt}
         format="hh:mm:ss"
         style={{
          fontSize: "21px",
          color: "#342800",
          fontWeight: "bold",
         }}
        />
        &nbsp;-{" "}
        <Time
         value={viewLoanRecipe.date}
         format="YYYY-MM-DD"
         style={{
          fontSize: "21px",
          color: "#000",
          fontWeight: "bold",
         }}
        />
       </p>
      </div>
      <div class="col-4 ">
       <p
        style={{
         fontSize: "24px",
         color: "black",
         fontWeight: "bold",
         margin: "0px 0px 0px 0px",
        }}
        class=" d-flex justify-content-center"
       >
        ({change_Lang("loan receipts")})
       </p>
      </div>
      <div class="col-4 text-left">
       <p
        style={{
         fontSize: "21px",
         color: "#000",
         fontWeight: "bold",
        }}
        class=" text-uppercase"
       >
        ژ.پسوولە#&nbsp;
        {invoiceNumber}&nbsp;
       </p>
      </div>
     </div>
     {/* first row */}
     <div class="row " style={{ width: "100%", backgroundColor: "#f4f4f6" }}>
      <div class="col-3 d-flex justify-content-start">
       {" "}
       <label
        style={{
         fontSize: "21px",
         color: "black",
         fontWeight: "bold",
        }}
        class=" col-form-label fk"
       >
        وەرگر/المستلم :
       </label>
      </div>
      <div class="col-6 d-flex justify-content-center">
       {" "}
       <label
        className="fk col-form-label d-flex justify-content-start"
        style={{
         fontSize: "21px",
         color: "black",
        }}
       >
        {viewLoanRecipe.type !== "PayBorrower"
         ? `${viewLoanRecipe.agentId && viewLoanRecipe.agentId.fname} ${
            viewLoanRecipe.agentId && viewLoanRecipe.agentId.lname
           }`
         : viewLoanRecipe.borrowerName}
       </label>
      </div>
      <div class="col-3 d-flex justify-content-end">
       <label
        style={{
         fontSize: "21px",
         color: "black",
         fontWeight: "bold",
        }}
        class=" col-form-label fkb"
       >
        : Receipt from
       </label>
      </div>
     </div>
     {/* second row */}
     <div class="row" style={{ width: "100%", backgroundColor: "white" }}>
      <div class="col-3 d-flex justify-content-start">
       {" "}
       <label
        style={{
         fontSize: "21px",
         color: "black",
         fontWeight: "bold",
        }}
        class=" col-form-label fk"
       >
        بڕی پارە/مبلغ و قدره :
       </label>
      </div>
      <div class="col-6 d-flex justify-content-center">
       {" "}
       <NumberFormat
        displayType="text"
        thousandSeparator={true}
        value={viewLoanRecipe.amount}
        style={{
         fontSize: "21px",
         color: "black",
        }}
        className="col-form-label"
        prefix={`${viewLoanRecipe.currency === "dolar" ? "$" : "ID"}`}
       />
       &nbsp;&nbsp;
       <span className="fk" style={{ fontWeight: "bold", marginTop: "12px" }}>
        {" "}
        {lang === "krd" ? numberWordsSorani : numWords1}&nbsp;
        {`${viewLoanRecipe.currency === "dolar" ? "دۆلاری ئەمریکی" : "دینار"}`}
        {change_Lang("Only")}
       </span>
      </div>
      <div class="col-3 d-flex justify-content-end">
       {" "}
       <label
        style={{
         fontSize: "21px",
         color: "black",
         fontWeight: "bold",
        }}
        class=" col-form-label fkb"
       >
        : Amount
       </label>
      </div>
     </div>
     {/* third row */}
     <div class="row" style={{ width: "100%", backgroundColor: "#f4f4f6" }}>
      <div class="col-3 d-flex justify-content-start">
       {" "}
       <label
        style={{
         fontSize: "21px",
         color: "black",
         fontWeight: "bold",
        }}
        class=" col-form-label fk"
       >
        لە بڕی / وذلك عن :
       </label>
      </div>
      <div class="col-6 d-flex justify-content-center">
       <span
        className="fk d-flex justify-content-center mt-2"
        style={{
         fontSize: "20px",
         color: "black",
         textAlign: "justify",
         fontWeight: "bold",
        }}
       >
        {viewLoanRecipe && change_Lang(viewLoanRecipe.type)}
       </span>
      </div>
      <div class="col-3 d-flex justify-content-end">
       {" "}
       <label
        style={{
         fontSize: "21px",
         color: "black",
         fontWeight: "bold",
        }}
        class=" col-form-label fkb"
       >
        : For
       </label>
      </div>
     </div>
     {/* five row */}
     <div class="row" style={{ width: "100%", backgroundColor: "white" }}>
      <div class="col-3 d-flex justify-content-start">
       {" "}
       <label
        style={{
         fontSize: "21px",
         color: "black",
         fontWeight: "bold",
        }}
        class=" col-form-label fk"
       >
        پارەدەر / الدافع :
       </label>
      </div>
      <div class="col-6 d-flex justify-content-center">
       {" "}
       <label
        className="fk col-form-label"
        style={{
         fontSize: "21px",
         color: "black",
        }}
       >
        {viewLoanRecipe.type !== "PayBorrower"
         ? viewLoanRecipe.borrowerName
         : `${viewLoanRecipe.agentId && viewLoanRecipe.agentId.fname} ${
            viewLoanRecipe.agentId && viewLoanRecipe.agentId.lname
           }`}
       </label>
      </div>
      <div class="col-3 d-flex justify-content-end">
       <label
        style={{
         fontSize: "21px",
         color: "black",
         fontWeight: "bold",
        }}
        class=" col-form-label"
       >
        : Receptor
       </label>
      </div>
     </div>
     {/* note */}
     <div class="row" style={{ width: "100%", backgroundColor: "#f4f4f6" }}>
      <div class="col-3 d-flex justify-content-start">
       {" "}
       <label
        style={{
         fontSize: "21px",
         color: "black",
         fontWeight: "bold",
        }}
        class=" col-form-label fk"
       >
        تێبینی / الملاحظات :
       </label>
      </div>
      <div class="col-6 d-flex justify-content-center">
       {" "}
       <label
        className="fk col-form-label"
        style={{
         fontSize: "18px",
         color: "black",
        }}
       >
        {viewLoanRecipe.notes}
       </label>
      </div>
      <div class="col-3 d-flex justify-content-end">
       <label
        style={{
         fontSize: "21px",
         color: "black",
         fontWeight: "bold",
        }}
        class=" col-form-label"
       >
        : Note
       </label>
      </div>
     </div>
     {/* six row */}
     <div
      class="row"
      style={{ width: "100%", position: "absolute", bottom: 40 }}
     >
      <div class="col-4 d-flex justify-content-center">
       {" "}
       <label
        style={{
         fontSize: "21px",
         color: "black",
         fontWeight: "bold",
        }}
        class=" col-form-label fk"
       >
        واژووی ڕێکخەر/ توقيع
       </label>
      </div>
      <div class="col-4 d-flex justify-content-center">
       {" "}
       <label
        style={{
         fontSize: "21px",
         color: "black",
         fontWeight: "bold",
        }}
        class=" col-form-label fk"
       >
        (پارەدەر)&nbsp;واژوو / توقيع
       </label>
      </div>
      <div class="col-4 d-flex justify-content-center">
       {" "}
       <label
        style={{
         fontSize: "21px",
         color: "black",
         fontWeight: "bold",
        }}
        class=" col-form-label fk"
       >
        (پارەوەرگر)&nbsp;واژوو / توقيع
       </label>
      </div>
      <div class="col-4 d-flex justify-content-center">
       {" "}
       <label
        style={{
         fontSize: "21px",
         color: "black",
         fontWeight: "bold",
        }}
        class=" col-form-label fk"
       >
        {lang === "krd" ? name_krd : lang === "en" ? name_en : name_arb}
       </label>
      </div>
      <div class="col-4 d-flex justify-content-center">
       {" "}
       <label
        style={{
         fontSize: "21px",
         color: "black",
         fontWeight: "bold",
         textAlign: "center",
        }}
        class=" col-form-label fk"
       >
        {viewLoanRecipe.type !== "PayBorrower"
         ? viewLoanRecipe.borrowerName
         : `${viewLoanRecipe.agentId && viewLoanRecipe.agentId.fname} ${
            viewLoanRecipe.agentId && viewLoanRecipe.agentId.lname
           }`}
       </label>
      </div>
      <div class="col-4 d-flex justify-content-center">
       {" "}
       <label
        style={{
         fontSize: "21px",
         color: "black",
         fontWeight: "bold",
         textAlign: "center",
        }}
        class=" col-form-label fk"
       >
        {viewLoanRecipe.type !== "PayBorrower"
         ? `${viewLoanRecipe.agentId && viewLoanRecipe.agentId.fname} ${
            viewLoanRecipe.agentId && viewLoanRecipe.agentId.lname
           }`
         : viewLoanRecipe.borrowerName}
       </label>
      </div>
     </div>
    </div>
   </Fragment>
  );
 }
}

const mapStateToProps = (state) => {
 return {
  lang: state.HelperReducer.lang,
  user: state.AuthReducer.user,
  primarycolor: state.HelperReducer.primarycolor,
  secondarycolor: state.HelperReducer.secondarycolor,
  primary_logo_bill: state.HelperReducer.primary_logo_bill,
  name_krd: state.HelperReducer.name_krd,
  name_arb: state.HelperReducer.name_arb,
  name_en: state.HelperReducer.name_en,
 };
};

const mapDispatchToProps = (dispatch) => {
 return {
  change_Lang: (key) => dispatch(change_Lang(key)),
 };
};

export default connect(mapStateToProps, mapDispatchToProps)(PrintViewLoan);
